import { render, staticRenderFns } from "./JoinInvestment.vue?vue&type=template&id=e529b936&scoped=true&"
import script from "./JoinInvestment.vue?vue&type=script&lang=js&"
export * from "./JoinInvestment.vue?vue&type=script&lang=js&"
import style0 from "./JoinInvestment.vue?vue&type=style&index=0&id=e529b936&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e529b936",
  null
  
)

export default component.exports